/**
 * The API returns opaque codes from OAuth callbacks instead of provider error
 * text, because the redirect URL is kept in browser history and sent as a
 * Referer. Details stay in the server log; the user gets an actionable message.
 */
const OAUTH_ERROR_MESSAGES: Record<string, string> = {
  oauth_failed: 'Die Verbindung konnte nicht abgeschlossen werden. Bitte erneut versuchen.',
  invalid_state: 'Die Sitzung ist abgelaufen oder das Netzwerk hat gewechselt. Bitte erneut verbinden.',
  missing_params: 'Der Anbieter hat die Anfrage unvollständig zurückgegeben. Bitte erneut verbinden.',
  access_denied: 'Der Zugriff wurde beim Anbieter abgelehnt.',
  user_denied: 'Der Zugriff wurde beim Anbieter abgelehnt.',
  consent_required: 'Die Freigabe wurde nicht erteilt. Bitte alle angeforderten Berechtigungen bestätigen.',
  provider_not_configured:
    'Dieser Kanal ist serverseitig noch nicht eingerichtet. Bitte App-Zugangsdaten unter Admin → Integrationen setzen.',
  quota_exceeded:
    'Das API-Kontingent ist aufgebraucht oder noch nicht freigegeben (oft 0 Anfragen/Minute bei neuen Google-Projekten). Basic API Access beantragen, dann erneut verbinden.',
  redirect_mismatch:
    'Die Redirect-URI im Entwicklerportal stimmt nicht mit der Callback-URL überein.',
  invalid_client: 'Client-ID oder Client Secret werden vom Anbieter abgelehnt. Bitte die Zugangsdaten prüfen.',
  invalid_grant: 'Der Autorisierungscode ist abgelaufen oder wurde bereits verwendet. Bitte erneut verbinden.',
  invalid_scope: 'Die angeforderten Berechtigungen werden vom Anbieter nicht akzeptiert.',
  permission_denied:
    'Der Anbieter hat den Zugriff verweigert. Berechtigungen, Testnutzer und App-Freigabe prüfen.',
  api_not_enabled: 'Die benötigte API ist im Cloud-Projekt nicht aktiviert oder nicht freigeschaltet.',
  token_exchange: 'Der Token-Austausch ist fehlgeschlagen. Bitte erneut verbinden.',
  no_accounts: 'Es wurde kein Konto oder keine Seite gefunden, die verbunden werden kann.',
  save_failed: 'Das Konto konnte nicht gespeichert werden. Bitte erneut versuchen.',
  temporarily_unavailable: 'Der Anbieter ist vorübergehend nicht erreichbar. Bitte später erneut versuchen.',
};

export function oauthErrorMessage(code: string | null | undefined): string {
  if (!code) return 'Verbinden fehlgeschlagen.';
  const text = OAUTH_ERROR_MESSAGES[code] ?? 'Verbinden fehlgeschlagen. Details stehen im Server-Log.';
  return `${text} (${code})`;
}
